export default "__VITE_ASSET__BrpSx8hZ__"